import { DropDownItem } from "./general";
import { KpiCategory, KpiConfiguration } from "./kpi-weight-management";

export interface Kpi {
  kpi_Id: number;
  kpiId: string;
  kpiName: string;
  kpi_Translation_Id: string;
  uom: string;

  kpiCategory: KpiCategory;
  kpiConfigurations: KpiConfiguration[];
}

export const GenerateKpiDropDownItems = (items: Kpi[]) => {
  if (!items) {
    return [];
  }

  return items.map(item => {
    return { value: item.kpiName, label: item.kpi_Translation_Id } as DropDownItem;
  })
};